<template>
     <SubLayout
        :pageTitle="title"
        :pageBreadcrumbs="breadcrumbs"
        :hasBack="false"
        :loading="false"
    >
        <template #subHeaderActions>
            <div class="d-flex flex-wrap align-items-center justify-content-end">

              <Button v-if="canSend && $can(abilities.UPDATE_EXPENSE)" btn-class="me-2 mb-2 btn-sm" @click.prevent="editExpense" type="new" btn-text="expense.edit" />
              <Button v-if="canSend && $can(abilities.SEND_EXPENSE)" btn-class="me-2 mb-2 btn-sm" @click.prevent="sendExpense" type="new" btn-text="expense.send" />
              <Button icon-class="fas fa-backspace" btn-class="btn-sm mb-2" type="cancel" btn-text="crm.back" @click.prevent="router.push({ name: 'expenses' })"/>
            </div>
        </template>
        <template #layoutContent>
          <Loader :isLoading="isLoading">
            <div class="row d-flex flex-wrap px-5">
                <div v-if="[expenseStatusEnums.PARTIALLY_PAID, expenseStatusEnums.PAID, expenseStatusEnums.VALIDATED].includes(expense.status)" class="card p-5 mb-4 me-md-5 flex-grow-1 col-12 col-md-3 col-lg-3">
                <Card class="p-5">
                  <div class="d-flex justify-content-between align-items-center py-4">
                    <span class="fw-bold fs-4"> {{ $t('expense.amountToCashOut') }} </span>
                    <span class="fw-bold fs-4"> {{ $formatLocalAmount(expense.fees_sum_amount) }} {{ expense.currency?.symbol }} </span>
                  </div>
                  <div class="separator" />
                  <div class="d-flex justify-content-between align-items-center py-4">
                    <span class="fw-bold text-primary fs-4"> {{ $t('expense.remainToPay') }} </span>
                    <span v-if="expense.status === expenseStatusEnums.PARTIALLY_PAID" class="fw-bold text-primary fs-4"> {{ $formatLocalAmount(expense.remaining) }} {{ expense.currency?.symbol }} </span>
                    <span v-else-if="expense.status === expenseStatusEnums.APPROVED" class="fw-bold text-primary fs-4"> {{ $formatLocalAmount(expense.fees_sum_amount) }} {{ expense.currency?.symbol }} </span>
                    <span v-else class="fw-bold text-primary fs-4"> {{ $formatLocalAmount("0") }} {{ expense.currency?.symbol }} </span>
                  </div>
                </Card>
                <Card v-if="expense.motif" class="card p-5 mt-auto">
                  <h3 class="text-danger"> {{ $t('expense.rejectReason') }} </h3>
                  <p class="fs-4"> {{ expense.motif }} </p>
                </Card>
              </div>
                <div class="card card-px-0 px-0 flex-grow-3 flex-md-grow-1 col-12 col-md-3 col-lg-3" style="flex: 1 1 60%;">
                    <Show :expense="expense" :currency="currency"/>
                </div>
            </div>
          </Loader>
        </template>
    </SubLayout>
</template>

<script setup>
import { ref, onMounted, computed, shallowRef} from "vue";
import SubLayout from "@/views/Layouts/partials/SubLayout.vue";
import { useRouter, useRoute } from 'vue-router';
import Loader from "@/components/Loader";
import Button from "@/components/Button";
import Show from "./components/Show.vue"
import {useSwal} from "@/composables/useSwal";
import {useStore} from "vuex";
import i18n from "@/plugins/i18n";
import { useLocales } from "@/composables/locales";
import Card from "@/components/Card.vue";
import {$formatLocalAmount} from "@/mixins/Helpers";
import {useExpenseEnums} from "@/Modules/Financial/composables/expenseEnums";
import abilities from "@/composables/abilities";

const {locale} = useLocales()
const store = useStore()
const router = useRouter()
const route = useRoute()

const {showSwal} = useSwal()
const { expenseStatusEnums } = useExpenseEnums()

const isLoading = ref(false)
const title = ref( "breadcrumbs.expense.title")

const showingAlert = ref(false)

const breadcrumbs = ref([
  {
    name: 'breadcrumbs.expense.list',
    route: 'expenses',
    params: {}
  },
  {
    name: 'breadcrumbs.expense.detail',
    route: 'expenses-view',
    params: route.params.id
  }
])


const modalId = ref('')

const isLoadingSend = ref(false)
const status = ref('')

const expense = computed(() => store.getters['expenses/currentExpense'])
const currency = computed(() => expense.value?.currency?.symbol)
const company = computed(() => store.getters['company/getCompanyInfos'])

const canSend = computed(() => {
  let status = expense?.value?.status
  return status == expenseStatusEnums.value.DRAFT || status == expenseStatusEnums.value.REJECTED

})

function editExpense(){
    router.push({ name: 'expenses-edit', params: {id: route.params.id} })
}

function sendExpense() {
  showSwal(
      i18n.global.t('expense.swal.send'),
      i18n.global.t('expense.swal.send_text')
  ).then( async (result) => {
    if (result.value) {
      isLoadingSend.value = true
      store.dispatch('expenses/sendExpense', route.params.id)
          .then(() => {
            $(modalId.value).modal('toggle');
            loadExpense()
            window.toastr['success'](i18n.global.t('notification.expense_sended'))
            alertDiv()
          })
          .catch(() => {
          })
          .finally(() => isLoadingSend.value = false)
    }
  })
}


const loadExpense = async () => {
    await store.dispatch('expenses/getExpensesById', route.params.id)
}

function loadData () {
  isLoading.value = true
  Promise.all([
    loadExpense(),
  ]).finally(() => isLoading.value = false)
}

onMounted(() => {
  loadData()
})

function alertDiv(){
    showingAlert.value = true;
    $('#sendModal').modal('toggle')
    setTimeout(() => {
        showingAlert.value = false;
      }, 5000);
}
</script>

<style scoped>
    .card-parent {
        position: relative;
    }

    .card-child {
        position: absolute;
        bottom: 0;
        width: 90%;
        font-weight: 500;
        margin-bottom: 20px;
    }
    .shadow {
        box-shadow: 0 0.1rem 0.5rem 0.1rem rgba(0, 0, 0, .075) !important;
    }
</style>
